import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  CmpDatePicker,
  CmpSelectField,
  CmpTypographyField,
} from "../../../Component/Common/ToolBox/ToolBox";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../../Utility/Utilitys";
import {
  common_brandbasedgroup_GETROW,
  common_brandgroup_GETROW,
  common_groupstructure_GETROW,
  common_VendorListReport_GETROW,
} from "../../../Server/ApiV2";
import axios from "axios";
import { getGlobals } from "../../../Configs";
import GCAutocompleteCheckboxFixSize from "../../../Component/Common/ReuseableComponent/GCAutocompleteCheckboxFixSize";
import moment from "moment";
import GCBrandSearch from "../../../Component/Common/ReuseableComponent/GCBrandSearch";
import GCSupplierSearch from "../../../Component/Common/ReuseableComponent/GCSupplierSearch";
const MasterModal = ({ vMediaQuery, xMediaQuery, loc, onClickSave }) => {
  const baseURL = getGlobals().API_BASE_URL;
  const sWebStockReportData = [
    { Uid: "All", Value: "ALL" },
    { Uid: "Is", Value: "Is" },
  ];

  const [sMainGroupData, setMainGroupData] = useState([]);
  const [sCategoryData, setCategoryData] = useState([]);
  const [sSubGroupData, setSubGroupData] = useState([]);
  const [sMainSupplierData, setMainSupplierData] = useState([]);
  const [sBrandData, setBrandData] = useState([]);
  const [sBrandCategoryData, setBrandCategoryData] = useState([]);
  const [itemGetRowData, setItemGetRowData] = useState([]);
  const [deleteInsert, setDeleteInsert] = useState("N");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectionModel, setSelectionModel] = useState([]);

  const HeadObjectInit = {
    // sLocation: "Is",
    sMainGroup: "All",
    sSubGroup: "All",
    sCategory: "All",
    sMainSupplier: "All",
    sBrand: "All",
    ageingInput: "0",
    fromDate: new Date(),
    toDate: new Date(),
    physicalCountEnd: new Date(),
    physicalCountStart: new Date(),
    sLocationArr: [],
    sLocationPrnt: "",
    sLocationCode: "",
    sLocationName: "",
    sMainGroupArr: [],
    sMainGroupPrnt: "",
    sMainGroupCode: "",
    sMainGroupName: "",
    sSubGroupArr: [],
    sSubGroupPrnt: "",
    sSubGroupCode: "",
    sSubGroupName: "",
    sCategoryArr: [],
    sCategoryPrnt: "",
    sCategoryCode: "",
    sCategoryName: "",
    sMainSupplierArr: [],
    sMainSupplierPrnt: "",
    sMainSupplierCode: "",
    sMainSupplierName: "",
    sSupplierSearchValue: "",
    sBrandArr: [],
    sBrandPrnt: "",
    sBrandCode: "",
    sBrandName: "",
    sBrandCategoryArr: [],
    sBrandCategoryPrnt: "",
    sBrandCategoryCode: "",
    sBrandCategoryName: "",

    sBrandSearchValue: "",
  };
  const [type, setType] = useState("General");
  const [masterData, setMasterData] = useState(HeadObjectInit);

  const fWmsStockRepotArr = async (xGroupStructureObj, setGroupData) => {
    let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
    const CurrentMaingroupArr = await common_groupstructure_GETROW(FinalObj);
    if (CurrentMaingroupArr?.status === 200) {
      setGroupData(CurrentMaingroupArr?.data?.ResultSet);
    }
  };

  const fMainGroup = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      sMainGroup: e.target.value,
      sMainGroupArr: [],
      sMainGroupPrnt: "",
      sMainGroupName: "",
      sSubGroup: "All",
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));
    setSubGroupData([]);
    setCategoryData([]);

    if (e.target.value.toUpperCase() == "ALL") {
      setMainGroupData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      let xGroupStructureObj = {
        Prnt: "",
        Lvl: "1",
      };
      await fWmsStockRepotArr(xGroupStructureObj, setMainGroupData);
    }
  };

  const fSubGroup = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));

    setCategoryData([]);
    if (e.target.value.toUpperCase() == "ALL") {
      setSubGroupData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      const mainGrpData = masterData?.sMainGroupArr
        .map((item) => `${item}`)
        .join(",");
      let xGroupStructureObj2 = {
        Prnt: mainGrpData,
        Lvl: "2",
      };
      await fWmsStockRepotArr(xGroupStructureObj2, setSubGroupData);
    }
  };

  const fCategory = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));

    if (e.target.value.toUpperCase() == "ALL") {
      setCategoryData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      const subGrpData = masterData?.sSubGroupArr
        .map((item) => `${item}`)
        .join(",");
      let xGroupStructureObj2 = {
        Prnt: subGrpData,
        Lvl: "3",
      };

      await fWmsStockRepotArr(xGroupStructureObj2, setCategoryData);
    }
  };

  const GetWmsStockRepotMainSupplier = async (setGroupData) => {
    const CurrentMaingroupArr = await common_VendorListReport_GETROW("");
    if (CurrentMaingroupArr?.status === 200) {
      setGroupData(CurrentMaingroupArr?.data?.ResultSet);
    }
  };

  const fMainSupplier = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sMainSupplierArr: [],
      sMainSupplierPrnt: "",
      sMainSupplierName: "",
    }));
    // if (e.target.value.toUpperCase() == "ALL") {
    //   setMainSupplierData([]);
    // } else if (e.target.value.toUpperCase() == "IS") {
    //   await GetWmsStockRepotMainSupplier(setMainSupplierData);
    // }
  };

  const GetWmsStockRepotBrand = async (setGroupData) => {
    const CurrentMaingroupArr = await common_brandgroup_GETROW("");
    if (CurrentMaingroupArr?.status === 200) {
      setGroupData(CurrentMaingroupArr?.data?.ResultSet);
    }
  };
  const fBrand = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sBrandArr: [],
      sBrandPrnt: "",
      sBrandName: "",
      sBrandCategoryArr: [],
      sBrandCategoryPrnt: "",
      sBrandCategoryCode: "",
      sBrandCategoryName: "",
    }));
    setBrandCategoryData([]);
    if (e.target.value.toUpperCase() == "ALL") {
      setBrandData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      await GetWmsStockRepotBrand(setBrandData);
    }
  };

  const fWmsStockRepotBrandArr = async (xGroupStructureObj, setGroupData) => {
    let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
    const CurrentMaingroupArr = await common_brandbasedgroup_GETROW(FinalObj);
    if (CurrentMaingroupArr?.status === 200) {
      setGroupData(CurrentMaingroupArr?.data?.ResultSet);
    }
  };

  const fBrand_Focus = (value) => {
    setMasterData((obj) => ({
      ...obj,
      sBrandCategoryArr: [],
      sBrandCategoryPrnt: "",
      sBrandCategoryCode: "",
      sBrandCategoryName: "",
    }));
  };

  const fBrandCategory_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setMasterData((obj) => ({
      ...obj,
      sBrandCategoryArr: value,
      sBrandCategoryPrnt: value?.length <= 0 ? "" : currentPrnt,
      sBrandCategoryName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const getCyclicCountItemGetRow = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    const mainGrpData = masterData?.sMainGroupArr
      .map((item) => `${item}`)
      .join(",");
    const subGrpData = masterData?.sSubGroupArr
      .map((item) => `${item}`)
      .join(",");
    const catGrpData = masterData?.sCategoryArr
      .map((item) => `${item}`)
      .join(",");
    const suplGrpData = masterData?.sMainSupplierArr
      .map((x) => x.AcCd)
      .join(", ");
    const brandGrpData = masterData?.sBrandArr.map((x) => x.UID).join(", ");
    try {
      console.log(brandGrpData, masterData?.sBrandArr, brandGrpData);

      const response = await axios.post(
        `${baseURL}physicalstock/WMPOIPT00ItemsMaster`,
        fcheck_null_undefine_replace_empty({
          MainGrp: mainGrpData,
          SubGrp: subGrpData,
          Grp: catGrpData,
          BrandCd: brandGrpData,
          Supplier: suplGrpData,
          Loc: loc,
          Type: type,
          Date1:
            type === "PO"
              ? moment(masterData?.fromDate).format("MM/DD/YYYY")
              : "01/01/2000",
          Date2:
            type === "PO"
              ? moment(masterData?.toDate).format("MM/DD/YYYY")
              : "01/01/2000",
          AgeingDay: masterData?.ageingInput,
          StockCountFrom: moment(masterData?.physicalCountStart).format(
            "MM/DD/YYYY"
          ),
          StockCountTo: moment(masterData?.physicalCountEnd).format(
            "MM/DD/YYYY"
          ),
        })
      );
      if (response?.status === 200) {
        loader.style.display = "none";
        setItemGetRowData(response?.data?.ResultSet);
      }
    } catch (error) {
      loader.style.display = "none";
    }
  };

  const handleSelectionChange = (selectedIds) => {
    if (!itemGetRowData) return;
    setSelectionModel(selectedIds);
    // Find the full object for each selected ID
    const selectedObjects = itemGetRowData?.filter((row) =>
      selectedIds.includes(row.ItmCd)
    );

    // Update state with full row data
    setSelectedRows(selectedObjects);
  };

  const handleChange = (key, value) => {
    setMasterData((prev) => ({ ...prev, [key]: value }));
  };

  const fSave = () => {
    let iArray = selectedRows?.map((obj) => ({
      B_ItmCd: obj.ItmCd,
      // P_B_CancelledQty: 0,
      // P_B_VoidQty: 0,
      // P_B_ReturnQt: 0,
      // P_B_AdjustQty: 0,
      // P_B_PurchaseReturnQty: 0,
      // P_B_SrQty: 0,
    }));

    console.log("iArray", iArray);

    onClickSave(iArray, deleteInsert);
  };
  useEffect(() => {
    GetWmsStockRepotMainSupplier(setMainSupplierData);
  }, []);
  useEffect(() => {
    if (masterData?.sBrandArr.length > 0) {
      fetchBrandCategory();
    }
  }, [masterData?.sBrandArr]);

  useEffect(() => {
    setMasterData((prev) => ({
      ...prev,
      sSubGroup: "All",
      sSubGroupArr: [],
    }));
  }, [masterData?.sMainGroupArr]);

  useEffect(() => {
    setMasterData((prev) => ({
      ...prev,
      sCategory: "All",
      sCategoryArr: [],
    }));
  }, [masterData?.sSubGroupArr]);

  const fetchBrandCategory = async () => {
    const subGrpData = masterData?.sBrandArr.map((item) => `${item}`).join(",");
    let xGroupStructureObj = {
      grp: subGrpData,
    };
    await fWmsStockRepotBrandArr(xGroupStructureObj, setBrandCategoryData);
  };

  return (
    <Box sx={{ paddingY: 1, paddingX: 0 }}>
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0.5, md: 1 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 1, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={2.5} sm={2} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Main Group"} />
            </Grid>
            <Grid item xs={2} sm={2} md={1.5} lg={1}>
              <CmpSelectField
                xtabIndex={"03"}
                xLabelText="sMainGroup"
                xValue={masterData?.sMainGroup}
                xOnChange={fMainGroup}
                xName={"sMainGroup"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={7.5} sm={8} md={9.2} lg={9.7}>
              <GCAutocompleteCheckboxFixSize
                options={sMainGroupData}
                xValue={masterData?.sMainGroupArr}
                xtabIndex={"04"}
                xDisabled={
                  masterData?.sMainGroup?.toUpperCase() === "ALL" ? true : false
                }
                setValue={setMasterData}
                objName="sMainGroupArr"
                label=""
                placeholder="Search Main Group"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 1, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={2.5} sm={2} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Sub Group"} />
            </Grid>
            <Grid item xs={2} sm={2} md={1.5} lg={1}>
              <CmpSelectField
                xtabIndex={"05"}
                xLabelText="sSubGroup"
                xValue={masterData?.sSubGroup}
                xOnChange={fSubGroup}
                xName={"sSubGroup"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={7.5} sm={8} md={9.2} lg={9.7}>
              <GCAutocompleteCheckboxFixSize
                options={sSubGroupData}
                xValue={masterData?.sSubGroupArr}
                xtabIndex={"06"}
                xDisabled={
                  masterData?.sSubGroup?.toUpperCase() === "ALL" ? true : false
                }
                setValue={setMasterData}
                objName="sSubGroupArr"
                label=""
                placeholder="Search Sub Group"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 1, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={2.5} sm={2} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Category"} />
            </Grid>
            <Grid item xs={2} sm={2} md={1.5} lg={1}>
              <CmpSelectField
                xtabIndex={"07"}
                xLabelText="sCategory"
                xValue={masterData?.sCategory}
                xOnChange={fCategory}
                xName={"sCategory"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={7.5} sm={8} md={9.2} lg={9.7}>
              <GCAutocompleteCheckboxFixSize
                options={sCategoryData}
                xValue={masterData?.sCategoryArr}
                xtabIndex={"08"}
                xDisabled={
                  masterData?.sCategory?.toUpperCase() === "ALL" ? true : false
                }
                setValue={setMasterData}
                objName="sCategoryArr"
                label=""
                placeholder="Search Category"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 1, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={2.5} sm={2} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Supplier"} />
            </Grid>
            <Grid item xs={2} sm={2} md={1.5} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sMainSupplier"
                xValue={masterData?.sMainSupplier}
                xOnChange={fMainSupplier}
                xName={"sMainSupplier"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={7.5} sm={8} md={9.2} lg={9.7}>
              {/* <GCAutocompleteCheckboxFixSize
                options={sMainSupplierData}
                xValue={masterData?.sMainSupplierArr}
                xtabIndex={"10"}
                xDisabled={
                  masterData?.sMainSupplier?.toUpperCase() === "ALL"
                    ? true
                    : false
                }
                setValue={setMasterData}
                objName="sMainSupplierArr"
                label=""
                placeholder="Search Supplier"
              /> */}
              <GCSupplierSearch
                xValue={masterData.sSupplierSearchValue} //main input value
                xOnChange={(e) => {
                  setMasterData((obj) => ({
                    ...obj,
                    // sBrandArr: e.target.value,
                    sSupplierSearchValue: e.target.value,
                  })); //main input onchange
                }}
                xReadOnly={
                  masterData?.sMainSupplier?.toUpperCase() === "ALL"
                    ? true
                    : false
                }
                basketValue={masterData?.sMainSupplierArr} //Search basket array
                xListValue={masterData?.sMainSupplierArr
                  .map((x) => x.Name1)
                  .join(", ")} // 2nd main input
                onApply={(selectedObjects) => {
                  setMasterData((obj) => ({
                    ...obj,
                    sMainSupplierArr: selectedObjects,
                  }));
                  // setBrandBasket(selectedObjects) //array of object
                }} // <- handle selected names
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 1, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={2.5} sm={2} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Brand"} />
            </Grid>
            <Grid item xs={2} sm={2} md={1.5} lg={1}>
              <CmpSelectField
                xtabIndex={"11"}
                xLabelText="sBrand"
                xValue={masterData?.sBrand}
                xOnChange={fBrand}
                xName={"sBrand"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            {/* <Grid item xs={7.5} sm={4} md={4.5} lg={5}>
              <GCAutocompleteCheckboxFixSize
                options={sBrandData}
                xValue={masterData?.sBrandArr}
                xtabIndex={"12"}
                xDisabled={
                  masterData?.sBrand?.toUpperCase() === "ALL" ? true : false
                }
                setValue={setMasterData}
                objName="sBrandArr"
                label=""
                placeholder="Search Brand"
              />
            </Grid> */}
            <Grid item xs={7.5} sm={8} md={9.2} lg={10}>
              <GCBrandSearch
                xValue={masterData?.sBrandSearchValue} //main input value
                xOnChange={(e) => {
                  setMasterData((obj) => ({
                    ...obj,
                    // sBrandArr: e.target.value,
                    sBrandSearchValue: e.target.value,
                  })); //main input onchange
                }}
                xReadOnly={
                  masterData?.sBrand?.toUpperCase() === "ALL" ? true : false
                }
                basketValue={masterData?.sBrandArr} //Search basket array
                xListValue={masterData?.sBrandArr
                  .map((x) => x.Name1)
                  .join(", ")} // 2nd main input
                onApply={(selectedObjects) => {
                  console.log("====================================");
                  console.log("selectedObjects", selectedObjects);
                  console.log("====================================");
                  setMasterData((obj) => ({
                    ...obj,
                    sBrandArr: selectedObjects,
                  }));
                  // setBrandBasket(selectedObjects) //array of object
                }} // <- handle selected names
              />
            </Grid>
            {/* <Grid item xs={3} sm={4} md={4} lg={5}>
              <GCAutocompleteCheckboxFixSize
                options={sBrandCategoryData}
                xValue={masterData?.sBrandCategoryArr}
                xtabIndex={"13"}
                xDisabled={
                  masterData?.sBrand?.toUpperCase() === "ALL" ||
                  masterData?.sBrandArr.length === 0
                    ? true
                    : false
                }
                setValue={setMasterData}
                objName="sBrandCategoryArr"
                label=""
                placeholder="Search Brand Category"
              />
            </Grid> */}
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            className="stock-detail"
            spacing={1}
            alignItems="center"
            sx={{ marginTop: "2px !important" }}
          >
            <Grid item xs={4} sm={2}>
              <FormControl size="small" fullWidth sx={{ height: "32px" }}>
                <Select
                  value={type}
                  onChange={(e) => {
                    setType(e.target.value);
                  }}
                  size="small"
                  sx={{
                    height: "32px",
                    // fontSize: "0.8rem",
                    ".MuiSelect-select": {
                      paddingTop: "6px",
                      paddingBottom: "6px",
                    },
                  }}
                  displayEmpty
                >
                  <MenuItem value="General">General</MenuItem>
                  <MenuItem value="PO">PO</MenuItem>
                  <MenuItem value="Ageing">Ageing</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {type === "PO" && (
              <Grid item xs={8} sm={6} md={5}>
                <Stack direction={"row"} spacing={1}>
                  <CmpDatePicker
                    xValue={masterData?.fromDate}
                    xOnChange={(newValue) =>
                      handleChange("fromDate", newValue.$d)
                    }
                    xFullWidth={true}
                    xLabelText={"From Date"}
                  />
                  <CmpDatePicker
                    xValue={masterData?.toDate}
                    xOnChange={(newValue) =>
                      handleChange("toDate", newValue.$d)
                    }
                    xFullWidth={true}
                    xLabelText={"To Date"}
                  />
                </Stack>
              </Grid>
            )}
            {type === "Ageing" && (
              <Grid item xs={4} sm={2}>
                <TextField
                  type="number"
                  label="Ageing Day"
                  size="small"
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    sx: {
                      height: 30, // Total height
                      fontSize: "0.8rem", // Optional: smaller text
                      padding: "0 8px",
                    },
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 30, // Ensures the root input field is resized
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem", // Optional: smaller label
                    },
                  }}
                  value={masterData?.ageingInput}
                  onChange={(e) => handleChange("ageingInput", e.target.value)}
                  fullWidth
                />
              </Grid>
            )}
            <Grid item xs={10.5} sm={6} md={5}>
              <Stack
                direction={"row"}
                spacing={1}
                sx={{ mt: { xs: 1, sm: 0 } }}
              >
                <CmpDatePicker
                  xValue={masterData?.physicalCountStart}
                  xOnChange={(newValue) =>
                    handleChange("physicalCountStart", newValue.$d)
                  }
                  xFullWidth={true}
                  xLabelText={"physical Count Start"}
                />
                <CmpDatePicker
                  xValue={masterData?.physicalCountEnd}
                  xOnChange={(newValue) =>
                    handleChange("physicalCountEnd", newValue.$d)
                  }
                  xFullWidth={true}
                  xLabelText={"physical Count To"}
                />
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container textAlign={"center"} marginTop={vMediaQuery ? 1 : 0}>
        <Grid item xs={4}>
          <Button
            variant="contained"
            sx={{
              height: "30px",
              width: vMediaQuery ? "" : "120px",
              mt: vMediaQuery ? 0 : 1,
              mr: 1,
              textTransform: "capitalize",
            }}
            onClick={() => {
              getCyclicCountItemGetRow();
            }}
          >
            Load
          </Button>
        </Grid>

        <Grid item xs={5} textAlign={"end"} marginTop={vMediaQuery ? 0.5 : 0.5}>
          <FormControlLabel
            sx={{
              "& .MuiCheckbox-root": {
                padding: vMediaQuery ? "0px !important" : "7px !important",
              },
            }}
            control={
              <Checkbox
                checked={deleteInsert === "Y"}
                onChange={(event) => {
                  setDeleteInsert(event.target.checked ? "Y" : "N");
                }}
                name="deleteInsert"
              />
            }
            label="Delete & Insert"
          />
        </Grid>
        <Grid item xs={3} textAlign={"start"}>
          <Button
            variant="contained"
            sx={{
              height: "30px",
              width: vMediaQuery ? "" : "120px",
              mt: vMediaQuery ? 0 : 1,
              mr: 1,
              textTransform: "capitalize",
            }}
            onClick={() => {
              if (itemGetRowData?.length > 0) {
                fSave();
              } else {
                fAlertToast("FAILED", "Grid should not be empty");
              }
            }}
          >
            Save
          </Button>
        </Grid>
      </Grid>
      <Box
        sx={{
          mt: 1,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          height: vMediaQuery ? "65vh" : "50vh",
          width: "100%",
        }}
      >
        <DataGrid
          rowHeight={30}
          headerHeight={40}
          components={{
            Toolbar: GridToolbar,
          }}
          rows={itemGetRowData ? itemGetRowData : ""}
          getRowId={(v) => v.ItmCd}
          columns={[
            {
              field: "ItmCd",
              headerName: "Item Code",
              width: xMediaQuery ? 100 : 110,
            },
            {
              field: "ItemName",
              headerName: "Item Name",
              width: xMediaQuery ? 250 : 350,
            },
            {
              field: "Category",
              headerName: "Category",
              width: xMediaQuery ? 150 : 110,
            },
            {
              field: "Brand",
              headerName: "Brand",
              width: xMediaQuery ? 150 : 130,
            },
            {
              field: "Vendor",
              headerName: "Vendor",
              width: xMediaQuery ? 250 : 300,
            },
            {
              field: "StockCount",
              headerName: "Stock Count",
              width: xMediaQuery ? 150 : 110,
              type: "number",
            },
          ]}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            border: 1,
            borderColor: "primary.light",
            ".MuiCheckbox-root": { padding: "4px !important" },
            ".MuiDataGrid-columnHeaderCheckbox": {
              width: vMediaQuery ? "30px !important" : "50px",
              minWidth: vMediaQuery ? "30px !important" : "50px",
            },
            ".MuiDataGrid-cellCheckbox": {
              minWidth: vMediaQuery ? "30px !important" : "50px",
              maxWidth: vMediaQuery ? "30px !important" : "50px",
            },
          }}
          hideFooter={itemGetRowData?.length < 100}
          // onRowClick={(params) => handleRowClick(params.row)}
          checkboxSelection // Enables checkboxes
          disableSelectionOnClick // Prevents row selection when clicking inside a row
          onSelectionModelChange={handleSelectionChange}
        />
      </Box>
    </Box>
  );
};

export default MasterModal;
